import React from 'react';
import DashboardTimeTracking from 'sections/dashboard/dashboard-time-tracking'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import SinglePersonHoursPie from './single-person-hours-pie'
import DashboardTimeTrackingOverview from 'sections/dashboard/dashboard-time-tracking-overview'

import {
	openModal
} from 'state/actions'

import {
	getCurrentAccount
} from 'state/selectors'

const SinglePersonTracking = props => {
    const {
        user,
        openModal,
        allTasks,
        allProjects,
        allMilestones,
        allSessions,
        accountData,
        loading
    } = props

    const commonProps = {
        allTasks,
        allMilestones,
        allProjects,
        userData: user
    }

    return (
        <div className="dashboard-container full-width-on-small-screen">
            <main>
                <div className="left-column">
                    <SinglePersonHoursPie
                        {...commonProps}
                        allSessions={allSessions}
                        accountData={accountData}
                        loading={loading}
                    />
                </div>
                <div className="right-column">
                    <DashboardTimeTracking
                        {...commonProps}
                        openModal={openModal}
                        isMini={true}
                        canEdit={false}
                    />
                </div>
                <div className="left-column">
                    <DashboardTimeTrackingOverview
                        thisUser={user} 
                        type="user"
                    />
                </div>
            </main>
        </div>
    )
};


const mapStateToProps = state => {
	return {
		allAccounts: state.account.entities.accounts,
		allTasks: state.account.entities.tasks,
		allMilestones: state.account.entities.milestones,
		allProjects: state.account.entities.projects,
		allFolders: state.account.entities.folders,
		allTodoDays: state.account.entities.todo_days,
		allTodos: state.account.entities.todos,
		allSessions: state.account.entities.sessions,
		accountData: getCurrentAccount(state)
	}
}

export default withRouter(connect(mapStateToProps, { 
	openModal
})(SinglePersonTracking))